// Čuvar korpe (sekcija "Talon bez karte"). Dvije zaštite:
//
// 1) Karta bez ecomm.ski zapisa (v2.0.10). Linija s formom osobe mora imati _ecomm_ski_product_id: bez njega se ime,
//    datum rođenja, fotografija i talon nigdje ne spremaju, a korpa je ipak puštala na plaćanje (OCBI10944, 10950,
//    10965, 10977, 10989, 11000). Ovdje: kreiraj zapis za takvu liniju i upiši ga u liniju, pa osvježi korpu. Dok to ne uspije,
//    plaćanje je zaključano i kupac vidi poruku.
//
// 2) Talon (naknada 5 KM za novi talon poštom) bez svoje karte: korpa ga skriva kao zasebnu stavku, pa kupac ostaje
//    s 5 KM koje ne može ukloniti. Nastaje kad karta nestane mimo dugmeta "Ukloni kartu" (npr. checkout je uklonio
//    rasprodanu kartu). Ovdje: ukloni takve talone; ako ne uspije, pokaži dugme "Ukloni talon bez karte".
//
// Zaštita od petlje: po jedan automatski pokušaj dok se ne učita korpa bez problema.
(function () {
  var API = 'https://admin.ecomm.ski/api/custom-products';
  var KEY = 'ag-orphan-try';
  var HEAL_KEY = 'ag-heal-try';
  var BLOCK_MSG = 'Jedna karta u korpi nije ispravno dodana. Uklonite je dugmetom "Ukloni kartu" i dodajte ponovo sa stranice paketa.';

  function get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { /* bez storage-a radi i dalje */ } }

  // ---------- 1) karta bez ecomm.ski zapisa ----------
  function brokenPersons() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ag-person]')).filter(function (p) {
      return !p.dataset.eid;
    });
  }

  var blockTimer = null;
  function showBlock() {
    // ag-season-cart.js osvježava dugme i poruku svakih 400 ms: poruka o neispravnoj karti se drži vidljivom
    if (!blockTimer) blockTimer = setInterval(function () { if (blocked()) showBlock(); }, 500);
    var pay = document.querySelector('[data-ag-pay]');
    var hint = document.querySelector('[data-ag-hint]');
    if (pay) { pay.dataset.ready = 'false'; pay.setAttribute('aria-disabled', 'true'); }
    if (hint) hint.textContent = BLOCK_MSG;
    brokenPersons().forEach(function (p) {
      if (p.querySelector('[data-ag-broken]')) return;
      var note = document.createElement('p');
      note.setAttribute('data-ag-broken', '');
      note.setAttribute('role', 'alert');
      note.className = 'ags-warn';
      note.textContent = BLOCK_MSG;
      var bar = p.querySelector('[data-ag-toggle]');
      if (bar && bar.parentNode) bar.parentNode.insertBefore(note, bar.nextSibling);
    });
  }

  function blocked() { return brokenPersons().length > 0; }

  // Plaćanje (klik ili Enter u polju) ne prolazi dok postoji takva karta. window capture ide prije svih ostalih handlera.
  function guard(event) {
    if (!blocked()) return;
    var t = event.target;
    var isPay = event.type === 'click' && t && t.closest && t.closest('[data-ag-pay]');
    var isSubmit = event.type === 'submit' && t && t.id === 'cart';
    if (!isPay && !isSubmit) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showBlock();
    var first = brokenPersons()[0];
    if (first) first.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  window.addEventListener('click', guard, true);
  window.addEventListener('submit', guard, true);

  async function createRecord(productId, variantId) {
    var response = await fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ shopify_product_id: String(productId), shopify_variant_id: String(variantId) }),
    });
    var json = await response.json();
    var id = json && json.data && json.data.id;
    if (!response.ok || !id) throw new Error('ecomm.ski: no record id');
    return id;
  }

  // Linije se popravljaju jedna po jedna: /cart/change mijenja ključ samo te linije, ostali ključevi ostaju važeći.
  async function heal(cart, persons) {
    for (var i = 0; i < persons.length; i++) {
      var key = persons[i].dataset.key;
      var line = cart.items.filter(function (it) { return it.key === key; })[0];
      if (!line) throw new Error('line not found: ' + key);
      var id = await createRecord(line.product_id, line.variant_id);
      var props = {};
      Object.keys(line.properties || {}).forEach(function (k) { props[k] = line.properties[k]; });
      props._ecomm_ski_product_id = id;
      var r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: line.quantity, properties: props }),
      });
      if (!r.ok) throw new Error('cart change failed: ' + r.status);
    }
    window.location.reload();
  }

  // ---------- 2) talon bez karte ----------
  function removeAll(orphans) {
    var updates = {};
    orphans.forEach(function (it) { updates[it.key] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart update failed: ' + r.status);
      window.location.reload();
    });
  }

  function showButton(orphans) {
    var host = document.querySelector('.ags-sum') || document.querySelector('[data-ag-cart]');
    if (!host || document.querySelector('[data-ag-orphan-btn]')) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ags-remove';
    button.setAttribute('data-ag-orphan-btn', '');
    button.textContent = 'Ukloni talon bez karte';
    button.addEventListener('click', function () {
      button.disabled = true;
      button.textContent = 'Uklanjam...';
      removeAll(orphans).catch(function (e) {
        console.error(e);
        button.disabled = false;
        button.textContent = 'Ukloni talon bez karte';
      });
    });
    host.appendChild(button);
  }

  function checkOrphans(cart) {
    var cards = {};
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._ecomm_ski_product_id) cards[String(p._ecomm_ski_product_id)] = true;
    });
    var orphans = cart.items.filter(function (it) {
      var p = it.properties || {};
      return p._delivery_for_ecomm_ski_product_id && !cards[String(p._delivery_for_ecomm_ski_product_id)];
    });
    if (!orphans.length) { set(KEY, null); return; }
    if (get(KEY) === '1') { showButton(orphans); return; }
    set(KEY, '1');
    removeAll(orphans).catch(function (e) {
      console.error(e);
      showButton(orphans);
    });
  }

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var broken = brokenPersons();
      if (broken.length) {
        if (get(HEAL_KEY) === '1') { showBlock(); return; }
        set(HEAL_KEY, '1');
        return heal(cart, broken).catch(function (e) {
          console.error('heal failed: ', e);
          showBlock();
        });
      }
      set(HEAL_KEY, null);
      checkOrphans(cart);
    })
    .catch(function (e) {
      console.error('cart check failed: ', e);
      if (blocked()) showBlock();
    });
})();
